import { store } from '@redux/store';
import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";
import uiStateSlice from 'layout/redux/uiStateSlice';

document.body.addEventListener('schedulerAnchorClick', () => {
    const googleAnalyticsDTO = new GoogleAnalyticsEvent('TDV Events', 'Clickthrough', 
    'Thank you page');
    store.dispatch(uiStateSlice.actions.trackUserEvent({ googleAnalyticsDTO }));
})